import React, { useState } from 'react'
import { Accordion, Card, Button } from "react-bootstrap";
import {
    Loading,
    Table as TableComponent,
} from "../../../Components";
import * as QLIBS from '../../../qLibsHelpers';
import { DEFAULT_HEADER } from '../../../Config/userToken';
import { APPCONFIG } from '../../../app.config';
import moment from 'moment';
import { Actions } from '../../../Components/GridComponents';
import { APIS } from '../../../Config/apis';
import userAuth from '../../../Config/userauth';
import InformationModal from '../../../Components/InformationModal';

const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

const requestOptions = {
    method: 'GET',
    headers: DEFAULT_HEADER.get()
};

const SectionEnum = {
    GrupoFamiliar: 1,
    DireccionPoliza: 2,
    Coberturas: 3,
    Beneficiarios: 4,
    ComposicionPremio: 5,
    FormaDePago: 6,
    Facturacion: 7,
    Rechazos: 8,
    Certificados: 9
};

const initSections = [
    {
        id: SectionEnum.GrupoFamiliar,
        title: 'Grupo Familiar',
        loaded: false,
        core: 'EOS'
    },
    {
        id: SectionEnum.DireccionPoliza,
        title: 'Dirección de Póliza',
        loaded: false,
        core: 'EOS'
    },
    {
        id: SectionEnum.Coberturas,
        title: 'Coberturas',
        loaded: false,
        core: 'EOS'
    },
    {
        id: SectionEnum.Beneficiarios,
        title: 'Beneficiarios',
        loaded: false,
        core: 'EOS'
    },
    {
        id: SectionEnum.ComposicionPremio,
        title: 'Composición de Premio',
        loaded: false,
        secondLevel: true,
        inMemoryData: false,
    },
    {
        id: SectionEnum.FormaDePago,
        title: 'Forma de Pago',
        loaded: false
    },
    {
        id: SectionEnum.Facturacion,
        title: 'Facturación',
        loaded: false,
        expandable: true,
        download: true,
        downloadName: 'Factura',
    },
    {
        id: SectionEnum.Rechazos,
        title: 'Rechazos',
        loaded: false,
        secondLevel: true
    },
    {
        id: SectionEnum.Certificados,
        title: 'Certificados',
        loaded: false,
        core: 'EOS',
        download: true,
        exportable: true,
    },
];

function dateFormat(val) {
    return val ? moment(val).format('DD/MM/YYYY') : null;
}


const columnsDef = {
    [SectionEnum.Certificados]: {
        "Certificado": { title: "Nro. Certificado" },
        "Asegurado": { title: "Asegurado" },
        "DNI": { title: "DNI" },
        "Desc_grupo": { title: "Actividad" },
        "Fecha_nacimiento": { title: "Fecha de Nacimiento", displayFormat: 'date' },
    },
    [SectionEnum.GrupoFamiliar]: {
        "NROLEDESC": { title: "Rol" },
        "SCLIENTDESC": { title: "Nombre" },
        "DBIRTHDAT": { title: "Fecha de nacimiento", displayFormat: 'date' },
        "NRODOC": { title: "Documento" },
    },
    [SectionEnum.DireccionPoliza]: {
        "SRECTYPEDESC": { title: "Tipo" },
        "SDESCADD": { title: "Dirección" },
        "SZIP_CODE": { title: "Código Postal" },
        "NLOCALDESC": { title: "Localidad" },
        "NPROVINCEDESC": { title: "Provincia" },
    },
    [SectionEnum.Coberturas]: {
        "NCOVERDESC": { title: " Nombre Cobertura" },
        "NCAPITAL": { title: "Suma Asegurada", displayFormat: 'money', width: 300, alignRight: true },
        "DEFFECDATE": { title: " Fecha Vigencia Desde", displayFormat: 'date', width: 300 },
    },
    [SectionEnum.Beneficiarios]: {
        "SCLIENTDESC": { title: "Nombre" },
        "DBIRTHDAT": { title: " Fecha de Nacimiento", displayFormat: 'date' },
        "NPARTICIP": { title: "Porcentaje de participación" },
        "NGROUPBEN": { title: "Orden Beneficiario" },
        "NRELATIONDESC": { title: "Relación" }
    },
    [SectionEnum.ComposicionPremio]: {
        "DESCRIPCION": { title: "Descripción", width: 300 },
        "PRIMA": { title: "Monto", displayFormat: 'money', summarizeCustom: 'NPREMIUM', 'signo': '$' },
    },
    [SectionEnum.FormaDePago]: {
        "SCLIENTDESC": { title: "Nombre" },
        "NTYP_CRECARDDESC": { title: "Tipo Tarjeta" },
        "SCREDI_CARDCONFIDENTIALIT": { title: "Número de Tarjeta" },
        "DCARDEXPIR": { title: "Fecha vencimiento de Tarjeta de Crédito", format: dateFormat },
        "NBANKEXTDESC": { title: "Banco" },
        "SCBU": { title: "Código CB" }
    },
    // [SectionEnum.Facturacion]: {
    //     "FacturaNumero": { title: "Nro. Factura" },
    //     "FechaEmision": { title: "Fecha Emisión", displayFormat: 'date' },
    //     "FechaInicioVigencia": { title: "Fecha Inicio vigencia", displayFormat: 'date' },
    //     "FechaFinVigencia": { title: "Fecha Fin vigencia", displayFormat: 'date' },
    //     "FechaConfirmacion": { title: "Última Aplicación", displayFormat: 'date' },
    //     "FechaVencimiento": { title: "Fecha de vencimiento", displayFormat: 'date' },
    //     "MontoCobro": { title: "Premio", displayFormat: 'money', alignRight: true },
    //     "MontoAdeudado": { title: "Saldo Pendiente", displayFormat: 'money', alignRight: true },
    //     "EstadoFacturaDescripcion": { title: "Estado" },
    // },
    [SectionEnum.Facturacion]: {
        "NRECEIPT": { title: "Nro. Factura" },
        "DISSUEDAT": { title: "Fecha Emisión", displayFormat: 'date' },
        "DEFFECDATE": { title: "Fecha Inicio vigencia", displayFormat: 'date' },
        "DEXPIRDAT": { title: "Fecha Fin vigencia", displayFormat: 'date' },
        "DPAYDATE": { title: "Última Aplicación", displayFormat: 'date' },
        "DLIMITDATE": { title: "Fecha de vencimiento", displayFormat: 'date' },
        "NPREMIUM": { title: "Premio" },
        "NBALANCE": { title: "Saldo Pendiente" },
        "NSTATUS_PREDESC": { title: "Estado" }
    },
    [SectionEnum.Rechazos]: {
        "DLEDGERDAT": { title: "Fecha Movimiento", displayFormat: 'date' },
        "BULLETINSNCOD_AGREEDESC": { title: "Medio de Pago" },
        "NPAYREJECTDESC": { title: "Causa de Rechazo" },
        "NBALANCE": { title: "Saldo" },
        "NBULLETINS": { title: "Cupon" }
    }
};

const exportMethods = {
    [SectionEnum.Certificados]: (props) => `datos/CertificadosIndividuales?agreBaseKey=${props.original.agre_Base_Key}&export=true`,
};

const apiMethods = {
    [SectionEnum.Certificados]: (props) => `datos/CertificadosIndividuales?agreBaseKey=${props.original.agre_Base_Key}`,
    [SectionEnum.GrupoFamiliar]: (props) => `producer/GetRoles?poliza=${props.original.agre_Base_Id}`,
    [SectionEnum.DireccionPoliza]: (props) => `producer/GetDirecciones?poliza=${props.original.agre_Base_Key}`,
    [SectionEnum.Coberturas]: (props) => `producer/GetCoberturas?poliza=${props.original.agre_Base_Id}`,
    [SectionEnum.Beneficiarios]: (props) => `producer/GetBeneficiarios?poliza=${props.original.agre_Base_Id}`,
    [SectionEnum.FormaDePago]: (props) => `producer/GetFormaPago?idRamo=${props.original.ramo}&idProducto=${props.original.productCodeVt}&idCertificado=${props.original.certificateNumber}&poliza=${props.original.policyNumberVt}`,
    //[SectionEnum.Facturacion]: (props) => `producer/GetFacturas?policyKey=${props.original.agre_Base_Key}`,
    [SectionEnum.Facturacion]: (props) => `producer/GetFacturas?idRamo=${props.original.ramo}&idProducto=${props.original.productCodeVt}&idCertificado=${props.original.certificateNumber}&poliza=${props.original.policyNumberVt}`,
    [SectionEnum.ComposicionPremio]: (props) => `producer/GetPremioAgrupado?factura=${props.original.NRECEIPT}`,
    [SectionEnum.Rechazos]: (props) => `producer/GetRechazos?idRamo=${props.original.ramo}&idProducto=${props.original.productCodeVt}&idCertificado=${props.original.certificateNumber}&factura=${props.original.NRECEIPT}`
};

const apiResponses = {
    [SectionEnum.GrupoFamiliar]: 'Beneficiarios',
    [SectionEnum.DireccionPoliza]: 'Direcciones',
    [SectionEnum.Coberturas]: 'Coberturas',
    [SectionEnum.Beneficiarios]: 'Beneficiarios',
    [SectionEnum.ComposicionPremio]: 'PremioAgrupado',
    [SectionEnum.FormaDePago]: 'FormaPago',
    [SectionEnum.Facturacion]: 'Facturas',
    [SectionEnum.Rechazos]: 'Rechazos',
    [SectionEnum.Certificados]: 'Certificados',
};

const inMemoryProperties = {
    [SectionEnum.ComposicionPremio]: [
        'MontoMensualCobro',
        'Sobreprima',
        'Extraprima',
        'PrimaDeRiesgo',
        'DecretoYRecargos',
        'RecargosFinancieros',
        'DerechoDeEmision',
        'Sellado',
        'BonificacionSelloProvincial',
        'TasaSuperintendencia',
        'IibbCaba',
        'Iva',
        'IvaAdicional',
        'Deduccion',
        'ImpuestosInternos',
        'TasasDeServicios',
    ],
};

const keyToLabelMap = {
    MontoMensualCobro: 'Prima de tarifa',
    Sobreprima: 'Sobre Prima',
    Extraprima: 'Extra Prima',
    PrimaDeRiesgo: 'Prima de Riesgo',
    DecretoYRecargos: 'Decreto y Recargos',
    RecargosFinancieros: 'Recargos Financieros',
    DerechoDeEmision: 'Derecho de Emisión',
    Sellado: 'Sellado',
    BonificacionSelloProvincial: 'Bonificación Sello Provincial',
    TasaSuperintendencia: 'Tasa Superintendencia',
    IibbCaba: 'IIBB CABA',
    Iva: 'IVA',
    IvaAdicional: 'IVA Adicional',
    Deduccion: 'Deducción',
    ImpuestosInternos: 'Impuestos Internos',
    TasasDeServicios: 'Tasas de Servicios',
};

function formatDescription(key) {
    return keyToLabelMap[key] || key.replace(/([a-z])([A-Z])/g, '$1 $2');
}


class PolicyDetailGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSize: props.pageSize,
            exportable: initSections.find(e => e.id === props.id)?.exportable,
            polizaId: props.original.id,
            columns: this.getColumns(props),
            data: [],
            loading: false,
            width: (props.width === undefined || props.width === null) ? '100%' : props.width.toString() + 'px'
        };
    }

    getColumns(props) {
        const section = initSections.find(e => e.id === props.id);
        const columns = QLIBS.getTableColumns(columnsDef[props.id])
        if (section.download && props.original.source === 'VT') {
            columns.unshift({
                Header: section.downloadName || "Certificado",
                accessor: "actions",
                width: 100,
                style: {
                    display: 'flex',
                    alignItems: 'center'
                },
                filterable: false,
                sortable: false,
                resizable: true,
                Cell: row => (
                    <Actions
                        hidden={!row.original.CanDownload}
                        icon="fas fa-file-download"
                        onDownload={() => props.id === SectionEnum.Facturacion ? this.downloadPdfInvoice(row) : this.downloadCertificate(row)}
                    />
                )
            });
        }
        return columns;
    }

    downloadPdfInvoice = (row) => {
        this.setState({ loading: true });
        const requestOptions = {
            method: 'GET',
            headers: DEFAULT_HEADER.get(),
        };
        const PRODUCERURL = APIS.URLS.DOWNLOAD_INVOICE;

        fetch(`${PRODUCERURL}?policyId=${this.state.polizaId}&invoiceNumber=${row.original.NRECEIPT}`, requestOptions)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                } else {
                    const errorText = await response.text();
                    let errorMessage = "Ocurrió un error.";
                    try {
                        const errorData = JSON.parse(errorText);
                        if (errorData.errors && Array.isArray(errorData.errors)) {
                            errorMessage = errorData.errors.join(" - ");
                        } else {
                            errorMessage = errorData.message || errorText;
                        }
                    } catch (e) {
                        errorMessage = errorText;
                    }
                    throw new Error(errorMessage);
                }
            })
            .then(data => {
                const byteArray = Uint8Array.from(atob(data.base64), c => c.charCodeAt(0));
                const blob = new Blob([byteArray], { type: data.mime_type || 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = data.name;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                this.setState({ showModal: true, modalMsg: 'No se pudo descargar la factura.' });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };


    downloadCertificate = (row) => {
        console.log(row.original);
        this.setState({ loading: true });
        const requestOptions = {
            method: 'GET',
            headers: DEFAULT_HEADER.get(),
        };
        const PRODUCERURL = APIS.URLS.DOWNLOAD_CERTIFICADO_INDIVIDUAL_TEMP;
        fetch(`${PRODUCERURL}?idPoliza=${this.state.polizaId}&email=${userAuth.email()}&certificado=${row.original.Certificado}`, requestOptions)
            .then(response => {
                if (response.ok) {
                    this.setState({ showModal: true, modalMsg: `En unos minutos recibirá el certificado en el correo electrónico ${userAuth.email()}.` });
                }
                else {
                    response.text()
                        .then((error) => {
                            let errorMessage = "Ocurrió un error.";
                            try {
                                const errorData = JSON.parse(error);
                                if (errorData.errors && Array.isArray(errorData.errors)) {
                                    errorMessage = errorData.errors.join(" - ");
                                }
                            } catch (e) {
                                errorMessage = error;
                            }
                            this.setState({ showModal: true, modalMsg: errorMessage });
                        });
                }
            })
            .catch(() => {
                this.setState({ showModal: true, modalMsg: 'No se pudo generar el certificado.' });
            }).finally(() => {
                this.setState({ loading: false });
            })
    }

    componentDidMount() {

        this.setState({ loading: true });
        const section = initSections.find(e => e.id === this.props.id);
        if (section.inMemoryData) {
            const properties = inMemoryProperties[this.props.id];

            const originalData = this.props.row._original;
            const dataArray = properties
                .filter(key => originalData.hasOwnProperty(key) && originalData[key] != null && originalData[key] !== 0)
                .map(key => ({
                    'DESCRIPCION': formatDescription(key),
                    'PRIMA': ['NC', 'AF'].includes(originalData.TipoCobranzaCodigo) ? originalData[key] * -1 : originalData[key],
                }));
            const parentOriginal = this.props.row?._original ?? this.props.original;
            dataArray.forEach(r => Object.defineProperty(r, "__parentOriginal", {
                value: parentOriginal, enumerable: false
            }));
            this.setState({ data: dataArray, loading: false });
        }
        else {
            fetch(`${PRODUCERURL}api/${apiMethods[this.props.id](this.props)}`, requestOptions)
                .then((response) => {
                    return response.json();
                })
                .then((data) => {

                    const dataArray = data[0] ? data[0][apiResponses[this.props.id]] : [];
                    const cols = columnsDef[this.props.id];
                    if (dataArray.length) {
                        for (let entity of dataArray) {
                            for (let colName in cols) {
                                const col = cols[colName];
                                if (col && col.format) {
                                    entity[colName] = col.format(entity[colName]);
                                }
                            }
                        }
                        const parentOriginal = this.props.row?._original ?? this.props.original;
                        dataArray.forEach(r => Object.defineProperty(r, "__parentOriginal", {
                            value: parentOriginal, enumerable: false
                        }));
                        this.setState({ data: dataArray });

                    }

                    this.setState({ loading: false });
                });
        }

    }

    changeSize = async (size) => {
        this.setState({ pageSize: size });
    }

    handleExport = () => {
        const section = initSections.find(e => e.id === this.props.id);
        const url = `${PRODUCERURL}api/${exportMethods[this.props.id](this.props)}`;
        const headers = new Headers(DEFAULT_HEADER.get());
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        fetch(url, {
            method: 'GET',
            headers: headers,
            redirect: 'follow'
        })
            .then(response => {
                if (response.ok) {
                    return response.blob();
                } else {
                    throw new Error('Error en la descarga del archivo');
                }
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${section.title}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(error => console.error('Error al descargar el archivo:', error));
    }
    render() {

        return (
            <>
                <Loading visible={this.state.loading}></Loading>
                {this.state.showModal && <InformationModal title='Descarga de certificado' icon='fas fa-info' message={this.state.modalMsg} onConfirm={() => this.setState({ showModal: false })}></InformationModal>}
                <div className="row my-3">
                    <div style={{ width: this.state.width }}>
                        {this.state.exportable && <div class="d-flex justify-content-end">
                            <Button className='m-2 downloadBtn'
                                onClick={this.handleExport}
                                size="small">
                                <i className="fas fa-file-download mx-2" />Descargar</Button></div>
                        }
                        <TableComponent
                            pageSize={this.state.pageSize}
                            onPageSizeChange={this.changeSize}
                            columns={this.state.columns}
                            data={this.state.data}
                            expandable={this.props.expandable}
                            subComponent={props => {
                                const propsJoin = Object.assign({},
                                    { ...this.props },
                                    { ...props },
                                    { original: Object.assign({}, { ...this.props.original }, { ...props.original }) })
                                return (<PolicyRowDetail secondLevel={this.props.expandable} {...propsJoin} />)
                            }} />

                    </div>
                </div>
            </>
        );
    }
}



const PolicyRowDetail = (props) => {
    const filteredSections = initSections.filter(e => e.secondLevel === props.secondLevel)
    const [sections, setSections] = useState(JSON.parse(JSON.stringify(filteredSections)));
    const loadSection = (id) => {
        const section = sections.find(e => e.id === id);
        if (section.loaded)
            return;

        const expandable = section.expandable && !props.secondLevel

        section.grid = <PolicyDetailGrid  {...props} id={id} expandable={expandable} />;

        setSections(sections.slice());
    };

    const disableToggle = props.original.core !== 'VT';

    const isEnabled = (id) => {
        if (id === SectionEnum.Certificados && !props.original.showCertificados)
            return false;

        if (props.original.core === 'VT')
            return true;

        const section = sections.find(e => e.id === id);
        return section.core && section.core === 'EOS'
    }

    return (

        <div className="m-4">
            {disableToggle && <>
                <div className="alert alert-warning" role="alert">
                    <i className="fas fa-info-circle icon"></i> Momentáneamente, algunas secciones de esta póliza están desactivadas.
                </div>
            </>}
            <Accordion defaultActiveKey="0">
                {sections
                    .filter(e => {
                        if (e.id === SectionEnum.Certificados) {
                            return props.original.policyType === 'COLECTIVA' && props.original.showCertificados;
                        }
                        return true;
                    })
                    .map(e => (
                        <Card key={e.id}>
                            <Card.Header>
                                <Accordion.Toggle
                                    as={Button}
                                    variant="link"
                                    eventKey={e.id}
                                    disabled={!isEnabled(e.id)}
                                    onClick={() => loadSection(e.id)}
                                >
                                    {e.title}
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey={e.id}>
                                <Card.Body>{e.grid}</Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    ))}
            </Accordion>

        </div>

    );
};

export default PolicyRowDetail;
